import type { Entry } from "@ascente/shared-types";
import { parseDate } from "./dateHelpers.js";

export type EntrySort = "date-desc" | "date-asc" | "created-desc" | "created-asc";

/**
 * Sort entries for the Entries tab.
 *
 * `originalOrder` is the id order as loaded from the sheet, which stands
 * in for creation time: the backend appends new rows, so a later row is
 * a newer entry. It is also the tiebreaker within a single date, which
 * keeps same-day entries from reordering between renders.
 */
export function sortEntries(
  entries: Entry[],
  sortBy: EntrySort,
  originalOrder: string[],
): Entry[] {
  const rowOf = new Map(originalOrder.map((id, i) => [id, i]));
  const direction = sortBy.endsWith("-desc") ? 1 : -1;

  return [...entries].sort((x, y) => {
    const xRow = rowOf.get(x.id) ?? 0;
    const yRow = rowOf.get(y.id) ?? 0;
    if (sortBy.startsWith("created")) return (yRow - xRow) * direction;

    const byDate = parseDate(y.date).getTime() - parseDate(x.date).getTime();
    if (byDate !== 0) return byDate * direction;
    return (yRow - xRow) * direction;
  });
}
